//学员成绩考核
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="学员考核成绩统计表"
    top="5%"
    width="50%"
    :center="true"
    :before-close="doClose"
  >
    <div class="archives_box">
      <div class="df" style="justify-content: flex-end; margin-bottom: 10px">
        <el-button
          class="bgc-bv"
          style="margin: 0 10px"
          size="mini"
          @click="handlUpdate()"
          >更新数据</el-button
        >
        <el-button
          class="bgc-bv"
          style="margin: 0 10px"
          size="mini"
          @click="doDownload()"
          >下载</el-button
        >
      </div>
      <div id="pdf-content3" style="height: 600px"></div>
    </div>
  </el-dialog>
</template>

<script>
import pdf from "pdfobject";
export default {
  name: "PerformanceAssessment",
  props: [],
  data() {
    return {
      dialogVisible: false,
      updated: 0,
    };
  },
  methods: {
    showPop(res) {
      this.playload = JSON.parse(res);
      this.queryData();
    },
    queryData() {
      let params = {
        phaseId: this.playload.phaseId,
        compId: this.playload.compId,
        updated: this.updated,
      };
      this.$post("/documentcenter/getLearnStatistic", params)
        .then((res) => {
          if (res.status == "0") {
            this.dialogVisible = true;
            this.updated = 0;
            this.$nextTick(() => {
              pdf.embed(res.data.viewUrl, "#pdf-content3", {
                pdfOpenParams: {
                  scrollbars: "0",
                  toolbar: "0",
                  statusbar: "1",
                },
              });
            });
          } else {
            this.dialogVisible = false;
          }
        })
        .catch(() => {
          this.dialogVisible = false;
        });
    },
    // 更新
    handlUpdate() {
      this.updated = 1;
      this.queryData();
    },

    // 下载
    doDownload() {
      this.$post("/documentcenter/getLearnStatistic", {
        phaseId: this.playload.phaseId,
        compId: this.playload.compId,
        updated: 0,
      }).then((res) => {
        // ;
        if (res.status == "0") {
          let url = res.data.downloadUrl || "";
          window.open(url);
        }
      });
    },
    doClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style>
</style>